import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heading } from './heading';

interface PageHeaderProps {
  backUrl: string;
  title: string;
  buttonHtml: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ backUrl, title, buttonHtml }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(backUrl);
  };

  return (
    <div
      id="header"
      className="tw:bg-brand-black-2 tw:border-b tw:border-zinc-100 tw:sticky tw:z-1 tw:top-0 tw:text-zinc-200 tw:dark:bg-zinc-700 tw:dark:border-zinc-400"
    >
      <div className="tw:max-w-7xl tw:mx-auto tw:px-6 tw:py-4">
        <div className="tw:flex tw:flex-col tw:sm:flex-row tw:items-center tw:justify-between">
          <div className="tw:flex tw:items-center tw:space-x-4">
            <button
              type="button"
              onClick={handleBackClick}
              className="fas fa-arrow-left tw:text-zinc-100 tw:cursor-pointer tw:hover:text-primary tw:bg-transparent tw:border-0 tw:!mr-4"
            />
            <Heading level={1} className="tw:text-zinc-100 tw:dark:!text-zinc-100">
              {title}
            </Heading>
          </div>
          <div className="tw:flex tw:flex-wrap tw:items-center tw:align-center tw:justify-center tw:gap-2">
            {buttonHtml}
          </div>
        </div>
      </div>
    </div>
  );
};
